<template>
    <div class="recommend">
             <drop-down-refresh :onRefresh="columnListRes">
                    <div>
                        <div class='importantNews_default'>
                        
                            <div class='contain'  v-if="isCloseSkeletonScreen">
                                <ul  class='contain_context'>
                                <import-news-item  v-for="(item,index) in columnStore" :key="index" :itemData="item"></import-news-item>
                                </ul>
                            </div>

                            <div v-if="!isCloseSkeletonScreen">
                            <SkeletonScreen  v-for="(item,index) in 5" :key=" index " />
                            </div>
                        </div>
                        <loading class="loadbox" style="padding: 12px 0;" loadType="small" :title="''" v-if="listLoading"></loading>
                        <read-more v-if="!hasMore&&!listLoading"></read-more>      
                    </div>
            </drop-down-refresh>
    </div>
</template>

<script>

import DropDownRefresh from '@/components/DropDownRefresh/index.vue';
import HomeApi from '@/api/importantNews/';
import importNewsItem from '@/components/importNewsItem/item';
import readMore from '@/components/readMore/';
import {scrollLoad} from "@/utils/index";

// import stock_pool from '@/assets/images/stock_pool2x.png';
// import mohu from '@/assets/images/mohu@2x.png';
// import SkeletonScreen from '@/components/SkeletonScreen' 



export default {
    name: 'Column',
    components: {
        readMore,
        importNewsItem,
        DropDownRefresh,
        // SkeletonScreen
    },
    data() {
        return {         
            hasMore: false,
            listLoading: false,
            before: '',
            columnStore: [{},{},{},{},{},{},{},{}],
            page: 1,
            // stock_pool,
            // mohu,
            isCloseSkeletonScreen: false,
            randomStr: Math.random().toString(36).slice(-4)

        };
    },
    created() {
        this.getColumnList()
    },
    mounted() {
        this.listenScrollFn();
    },
    methods: {

        columnListMore() {
            if (!this.hasMore || this.listLoading) return
            this.before = this.columnStore[this.columnStore.length-1].rec_time;
            this.page++
            this.getColumnList()
        },
        
        async getColumnList() {
            // this.hasMore = false
            this.listLoading = true
            let data = await HomeApi.getImportantNewsList2(this.before);
            // 分享
            this.$share(data.share)
          

            this.isCloseSkeletonScreen = true;
            if (!this.before) {
                this.columnStore = data.data
            } else {
                this.columnStore = this.columnStore.concat(data.data)
            }
            this.hasMore = true
            this.listLoading = false
            if (this.page < 2) {
                this.hasMore = true
            } else {

                this.hasMore = false
            }
        },
        listenScrollFn() {
            let that = this;
            window.document.addEventListener('scroll',scrollLoad(that.columnListMore),false);
        },
        columnListRes(refreshDone){
            this.isCloseSkeletonScreen = false
            this.page = 1
            this.before=''
            this.columnStore= [{},{},{},{},{},{},{},{}]
            this.getColumnList();
            refreshDone();
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

.detail_header_small{
    display: none!important;
}
.recommend {
    // position: fixed;
    // overflow: auto;
    // top: 48px;
    padding-top: 50px;
    width: 100%;
    padding-bottom: 50px;
    // bottom: 0;
    background-color: #F0F0F0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.importantNews_default {
    padding-top: 10px;
    width: 100%;
    background-color: #F0F0F0;
    height: 100%;

    .loading2 {
        position: absolute;
        padding-left: 142px;
        bottom: 46px;
        vertical-align: middle;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #939393;
        background-color: #F0F0F0;
        width: 100%;

        img {
            width: 20px;
            height: 20px;
            margin-right: 9px;
        }
    }
}

.main {
    width: 100%;
    background-color: #F0F0F0;
    height: 100%;

    .loading {
        position: absolute;
        display: inline;
        top: 60px;
        left: 142px;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #939393;
        vertical-align: middle;

        img {
            width: 20px;
            height: 20px;
            margin-right: 9px;
        }
    }
}

.contain {
    padding: 10px 14px 0 14px;
    background-color: #FFFFFF;

    ul {

    }
}

.noAction {
    width: 100%;
    font-size: 16px;
    text-align: left;
    overflow: hidden;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    //最多3行显示
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-height: 22px;
}

.active {
    color: #C7000A;
}

.multimedia {
    height: 100px;
    margin-top: 7px;
    margin-bottom: 7px;

    div {
        margin-right: 10px;
    }

    >img {
        margin-right: 10px;
    }
}

.stock_pool {
    margin: 11px 0 13px 0;
    width: 100%;
    height: 32px;
    background-color: #FBF7F3;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .stock_pool_head {
        font-size: 12px;
        color: #5B5B5B;
        width: 96px;
        height: 14px;
        letter-spacing: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4px 0 6px !important;

        >img {
            width: 13px;
            height: 14px;
        }

        span {
            height: 14px;
            line-height: 14px;
        }
    }

    .stock_pool_foot {
        width: 60px;
        height: 14px;
        font-size: 12px;
        text-align: right;
        line-height: 14px;
        display: inline-block;
        color: #5B5B5B;
        margin-right: 9px;
    }

    >div {
        width: 200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        >img {
            width: 100px;
            height: 100%;
        }

        @media screen and (max-width: 410px) {
            .img_two {
                display: none;
            }
        }
    }
}


//首页的部分样式
.home_importNewsFoot {
    width: 100%;
    margin-top: 14px;
    position: relative;
    margin-bottom: 10px;

    a {
        color: #1C88D0;
        font-size: 13px;
        width: 96px;
        display: inline-block;
    }

    p {
        margin-bottom: 5px;
        margin-top: 5px;
        color: #898989;
        font-family: PingFang-SC-Medium;
        font-weight: SC-Medium;
        font-size: 12px;
        position: absolute;
        right: 0;
        display: inline-block;

        span {
            margin-right: 13px;
        }

        img {
            margin-right: 1px;
            width: 14px;
            height: 12px;
            display: inline-block;
        }
    }
}

.i_type {
    font-family: PingFang-SC-Bold;
    display: inline-block;
    font-weight: bold;
    margin-right: 5px;
    color: #C7000A;
}
</style>